module.exports = __webpack_public_path__ + "static/media/2.34d76db8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/2.jpg
// module id = 535
// module chunks = 0